import "./slicing/src/assets/scss/main.scss"
